"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var AuthHeaders_1 = require("src/app/api/AuthHeaders");
var http_2 = require("@angular/common/http");
var http_3 = require("@angular/common/http");
var FileModels_1 = require("./../../Models/FileModels");
var upload_file_queue_component_1 = require("./../upload-file-queue/upload-file-queue.component");
var core_1 = require("@angular/core");
var service_service_1 = require("../../Services/service.service");
var forms_1 = require("@angular/forms");
var subscribtion_service_1 = require("../../Services/subscribtion.service");
var angular_cc_library_1 = require("angular-cc-library");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var environment_1 = require("src/environments/environment");
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["PremiumAdToken"] = 0] = "PremiumAdToken";
    PaymentType[PaymentType["WriteAdToken"] = 1] = "WriteAdToken";
    PaymentType[PaymentType["ThirdPartyToken"] = 2] = "ThirdPartyToken";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var BanerPlatform;
(function (BanerPlatform) {
    BanerPlatform[BanerPlatform["Desktop"] = 0] = "Desktop";
    BanerPlatform[BanerPlatform["Mobile"] = 1] = "Mobile";
})(BanerPlatform = exports.BanerPlatform || (exports.BanerPlatform = {}));
var imageSizes = { 0: { w: 160, h: 600 }, 1: { w: 728, h: 90 }, 2: { w: 300, h: 100 } };
var BanerTokenPaymentComponent = /** @class */ (function () {
    function BanerTokenPaymentComponent(services, fb, subscribtionService, HttpClient) {
        this.services = services;
        this.fb = fb;
        this.subscribtionService = subscribtionService;
        this.HttpClient = HttpClient;
        this.creating = false;
        this.banerPlatform = BanerPlatform.Desktop;
        this.paymentFormType = PaymentType.PremiumAdToken;
        this.payButtonText = "Pay";
        this.onTokenAdded = new core_1.EventEmitter();
        this.This = this;
        this._termsNotAccepted = true;
        this.imagesChanged = false;
        this._selectedImages = [];
    }
    Object.defineProperty(BanerTokenPaymentComponent.prototype, "termsNotAccepted", {
        get: function () {
            return this._termsNotAccepted;
        },
        set: function (value) {
            this._termsNotAccepted = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BanerTokenPaymentComponent.prototype, "selectedImages", {
        get: function () {
            return this._selectedImages;
        },
        enumerable: true,
        configurable: true
    });
    BanerTokenPaymentComponent.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            firstName: ['', [forms_1.Validators.required]],
            lastName: ['', [forms_1.Validators.required]],
            zip: ['', [forms_1.Validators.required]],
            creditCard: ['', [angular_cc_library_1.CreditCardValidator.validateCCNumber]],
            expirationDateYear: ['', [forms_1.Validators.required]],
            expirationDateMonth: ['', [forms_1.Validators.required]],
            cvc: ['', [forms_1.Validators.required, forms_1.Validators.minLength(3), forms_1.Validators.maxLength(4)]],
            banerUrl: ['', [forms_1.Validators.required]]
        });
    };
    BanerTokenPaymentComponent.prototype.onSubmit = function () {
        if (this.form.dirty && this.form.valid) {
            if (!this.termsNotAccepted) {
                if (this.selectedImages[0] && this.selectedImages[1] && this.banerPlatform == BanerPlatform.Desktop) {
                    this.sendForm();
                }
                else if (this.selectedImages[2] && this.banerPlatform == BanerPlatform.Mobile) {
                    this.sendForm();
                }
                else {
                    this.services.showError("Please select image");
                }
            }
            else {
                this.services.showError("Please accept terms");
            }
        }
    };
    BanerTokenPaymentComponent.prototype.sendForm = function () {
        var _this = this;
        var data = new WickedApiClient_1.AddBaner({
            firstName: this.form.controls["firstName"].value,
            lastName: this.form.controls["lastName"].value,
            cardNumber: this.form.controls["creditCard"].value,
            expirationDate: this.form.controls["expirationDateYear"].value + "-" + this.form.controls["expirationDateMonth"].value,
            zip: this.form.controls["zip"].value,
            securityCode: this.form.controls["cvc"].value,
            banerUrl: this.form.controls["banerUrl"].value,
            desktopImageVertical: this.banerPlatform == 0 ? this.selectedImages[0].imageUrl : "",
            desktopImageHorizontal: this.banerPlatform == 0 ? this.selectedImages[1].imageUrl : "",
            mobileImage: this.banerPlatform == 1 ? this.selectedImages[2].imageUrl : "",
            isMobile: this.banerPlatform
        });
        this.creating = true;
        this.subscribtionService.createBanerAdvertising(data).then(function (response) {
            _this.creating = false;
            _this.onTokenAdded.emit(response);
        });
    };
    //image uplad functions
    BanerTokenPaymentComponent.prototype.isImage = function (file) {
        var name = file.name.toLowerCase();
        return name.endsWith(".jpg") || name.endsWith(".gif") || name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".bmp");
    };
    BanerTokenPaymentComponent.prototype.addFile = function (file, inputId) {
        var _this = this;
        if (inputId === void 0) { inputId = null; }
        console.log(file);
        if (this.isImage(file) && typeof inputId == 'number') {
            var fi = new FileModels_1.FileInfo();
            fi.file = file;
            fi.fileName = file.name;
            fi.name = file.name;
            fi.orgFileName = file.name;
            //fi.advertisementId = this.adv ? this.adv.advertisementId : null;
            var reader = new FileReader();
            reader.onload = function (e) {
                var readerSrc = e.target["result"].toString();
                var image = new Image();
                image.src = readerSrc;
                image.onload = function () {
                    if ((image.width == imageSizes[inputId].w && image.height == imageSizes[inputId].h)) {
                        fi.imageUrl = reader.result;
                        _this.uploadFile(fi);
                        if (!_this.selectedImages[inputId]) {
                            _this.selectedImages[inputId] = fi;
                        }
                        _this.imagesChanged = true;
                    }
                    else {
                        _this.services.showError("Please select an image with the correct resolution 160x600 or 728x90");
                    }
                };
            };
            reader.readAsDataURL(fi.file);
        }
    };
    BanerTokenPaymentComponent.prototype.deleteImage = function (file, inputId) {
        if (this.selectedImages[inputId] == file) {
            this.setSelectedImages(undefined, inputId);
        }
        this.imagesChanged = true;
    };
    BanerTokenPaymentComponent.prototype.uploadFile = function (file) {
        var _this = this;
        var url = "/File/TemporaryBanerUpload";
        var formData = new FormData();
        var token = AuthHeaders_1.getAuthToken();
        var headers = new http_2.HttpHeaders(); //.set('Content-Type', 'multipart/form-data');
        var httpRequestParams = new http_1.HttpParams();
        headers.set("Authorization", "Bearer " + token);
        formData.set("file", file.file, file.file.name);
        this.services.progress = true;
        this.HttpClient.post(url, formData, {
            headers: headers,
            observe: "events",
            params: httpRequestParams,
            reportProgress: true,
            responseType: "json"
        }).subscribe(function (event) {
            if (event.type === http_2.HttpEventType.UploadProgress) {
                file.progressPercentage = Math.floor((event.loaded * 100) / event.total);
                file.loaded = event.loaded;
            }
            if (event.type == http_2.HttpEventType.Response) {
                var eventResponse = event;
                if (eventResponse.body && eventResponse.ok) {
                    if (eventResponse.body.isBanerSize) {
                        file.fileName = eventResponse.body.files[0].localFilename;
                        file.isUploading = false;
                        file.imageUrl = environment_1.environment.apiBaseUrl + "/FileGet/" + file.fileName;
                    }
                    else {
                        _this.services.showError("Please select an image with the correct resolution 160x600, 728x90 or 300x100 for mobile");
                    }
                }
                _this.services.progress = false;
            }
        }, function (error) {
            file.isUploading = false;
            _this.services.progress = false;
        }, function () {
        });
    };
    BanerTokenPaymentComponent.prototype.setSelectedImages = function (value, index) {
        console.log(value);
        if (value != this._selectedImages[index]) {
            this.imagesChanged = true;
        }
        this._selectedImages[index] = value;
    };
    BanerTokenPaymentComponent.prototype.termsAcceptAction = function (e) {
        this.termsNotAccepted = !e.checked;
    };
    BanerTokenPaymentComponent.prototype.changeBanerPlatform = function (e) {
        this.banerPlatform = e.value;
    };
    BanerTokenPaymentComponent.prototype.isBanerMobile = function () {
        return this.banerPlatform == BanerPlatform.Mobile;
    };
    return BanerTokenPaymentComponent;
}());
exports.BanerTokenPaymentComponent = BanerTokenPaymentComponent;
